export enum QueryKey {
  Appointments = "appointments",
  AppointmentExchanges = "appointmentExchanges",
  AppointmentTakeovers = "appointmentTakeovers",
  AppointmentTakeoverHistory = "appointmentTakeoverHistory",
  Counselors = "counselors",
  CounselorWorkTime = "counselorWorkTime",
  CounselorDutyPreferences = "counselorDutyPreferences",
  CounselorPresence = "counselorPresence",
  CurrentUser = "currentUser",
  DropdownOptions = "dropdownOptions",
  LastOpenedClients = "lastOpenedClients",
  Clients = "clients",
  ClientCaseNotes = "clientCaseNotes",
  Client = "client",
  ClientChangeInfo = "clientChangeInfo",
  ClientChangeHistory = "clientChangeHistory",
  ClientDocuments = "clientDocuments",
  ClientDocumentPreview = "clientDocumentPreview",
  ClientSelfDocuments = "clientSelfDocuments",
  ActiveUploadLink = "activeUploadLink",
  ClientPortalAccountStatus = "clientPortalAccountStatus",
  PortalEmailAvailability = "portalEmailAvailability",
  ClientVolunteerAssignment = "clientVolunteerAssignment",
  DropZoneFiles = "dropzoneFiles",
  Assignments = "assignments",
  ClientOverview = "clientOverview",
  Ambulanzes = "ambulanzes",
  ClientPersonalData = "clientPersonalData",
  ClientGoals = "clientGoals",
  ClientStatusCounselor = "clientStatusCounselor",
  SrvProceeding = "srvProceeding",
  ClientDebts = "clientDebts",
  MaintenanceBanner = "maintenanceBanner",
  ProceedingParticipants = "proceedingParticipants",
  Courts = "courts",
  AvailableCourtDistricts = "availableCourtDistricts",
  SmsTemplates = "smsTemplates",
  CaseNoteTemplates = "caseNoteTemplates",
  EmailTemplates = "emailTemplates",
  SystemDropdownCategories = "systemDropdownCategories",
  SystemDropdownOptions = "systemDropdownOptions",
  Volunteers = "volunteers",
  VolunteerAssignedClients = "volunteerAssignedClients",
  VolunteerPortalAccountStatus = "volunteerPortalAccountStatus",
  CreditorProtectionAssociations = "creditorProtectionAssociations",
  ClientClaims = "clientClaims",
  ClaimById = "claimById",
  JournalSupports = "journalSupports",
  SystemSetting = "systemSetting",
  CalculationParameters = "calculationParameters",
  AmsParameters = "amsParameters",
  BankruptcyChecklist = "bankruptcyChecklist",
  ViennaAddressImportStatus = "viennaAddressImportStatus",
  PublicHolidays = "publicHolidays",
  ViennaAddresses = "viennaAddresses",
  AssetInventory = "assetInventory",
  AssetInventoryDependants = "assetInventoryDependants",
  AssetInventoryDependantDocuments = "assetInventoryDependantDocuments",
  SeizableIncomeCalculation = "seizableIncomeCalculation",
  SeizableIncomePeriods = "seizableIncomePeriods",
  AssetInventoryBankStatements = "assetInventoryBankStatements",
  AssetInventoryCompleteness = "assetInventoryCompleteness",
  AssetInventoryExpenses = "assetInventoryExpenses",
  AssetInventoryIncome = "assetInventoryIncome",
  AssetInventoryIncomeProofs = "assetInventoryIncomeProofs",
  AssetInventoryExpenseProofs = "assetInventoryExpenseProofs",
  AssetInventoryExpensePartner = "assetInventoryExpensePartner",
  AssetInventoryOwnClaims = "assetInventoryOwnClaims",
  AssetInventoryOwnClaimDocuments = "assetInventoryOwnClaimDocuments",
  AssetInventoryAssets = "assetInventoryAssets",
  AssetInventoryDomesticRealEstateDocuments = "assetInventoryDomesticRealEstateDocuments",
  AssetInventoryForeignRealEstateDocuments = "assetInventoryForeignRealEstateDocuments",
  AssetInventoryBuildingSavingsContractDocuments = "assetInventoryBuildingSavingsContractDocuments",
  AssetInventorySavingsAccountDocuments = "assetInventorySavingsAccountDocuments",
  AssetInventoryLifeInsuranceDocuments = "assetInventoryLifeInsuranceDocuments",
  AssetInventoryPensionInsuranceDocuments = "assetInventoryPensionInsuranceDocuments",
  AssetInventorySecuritiesDepotDocuments = "assetInventorySecuritiesDepotDocuments",
  AssetInventoryCashAndBankAssetDocuments = "assetInventoryCashAndBankAssetDocuments",
  AssetInventoryVehicleDocuments = "assetInventoryVehicleDocuments",
  AssetInventoryBuildingsOnForeignLandDocuments = "assetInventoryBuildingsOnForeignLandDocuments",
  AssetInventoryPropertyRights = "assetInventoryPropertyRights",
  AssetInventoryTenancyRightDocuments = "assetInventoryTenancyRightDocuments",
  AssetInventoryCompanyShareDocuments = "assetInventoryCompanyShareDocuments",
  AssetInventoryCooperativeMembershipDocuments = "assetInventoryCooperativeMembershipDocuments",
  AssetInventoryOtherPropertyRightDocuments = "assetInventoryOtherPropertyRightDocuments",
  AssetInventoryDonations = "assetInventoryDonations",
  AssetInventoryDonationDocuments = "assetInventoryDonationDocuments",
  DutySchedules = "dutySchedules",
  DutyScheduleDetail = "dutyScheduleDetail",
  DutyScheduleCounselorOptions = "dutyScheduleCounselorOptions",
  DutyScheduleDistributionSummary = "dutyScheduleDistributionSummary",
  Edicts = "edicts",
  EdictDocument = "edictDocument",
  CaseNoteEdict = "caseNoteEdict",
  PriorityRequests = "priorityRequests",
  InternetRegistrations = "internetRegistrations",
  AttendanceOverview = "attendanceOverview",
  CourtHearings = "courtHearings",
  MailMergeFolderGrant = "mailMergeFolderGrant",
  UserSettings = "userSettings",
}
